module.exports = __webpack_public_path__ + "static/media/DC-logo-lite.148512a6.png";